import React from 'react'
import imgAutoService from "Assets/images/autoservicio-destock1.jpg";
import imgAutoServiceMobil from 'Assets/images/autoservicio-destock1.jpg';
import CountdownTimer from 'Components/CountdownTimer';


const AutoService = () => {
  return (
    <div className='relative'>
        <img src={imgAutoService} alt="autoservice" className="w-full h-[1020px] relative hidden md:block object-cover" />
        <img src={imgAutoServiceMobil} alt="autoservice" className="w-full h-auto relative block md:hidden" />
        <CountdownTimer targetDate="2025-07-23T00:00:00" style="absolute left-20 bottom-[300px] md:!bottom-[326px] md:left-[150px]" />
        <a href="https://c1.presik.com/app/PRESIKSAS/crm_form_prospect" target='_blank' className='absolute !bottom-[206px] left-10 md:!bottom-[226px] md:left-[160px] text-xl md:text-6xl  lg:text-2xl md:mt-0 bg-yellow-300 lg:w-max rounded-full py-2 px-3 md:px-6 justify-center hover:scale-110 duration-100 ease-linear transform hover:text-black flex gap-4 items-center md:w-52'>SOLICITAR INFORMACIÓN</a>
    </div>
  )
}

export default AutoService